__turbopack_context__.v({
  "container": "MaintenancePage-module-scss-module__URXJjq__container",
  "content": "MaintenancePage-module-scss-module__URXJjq__content",
  "countdown": "MaintenancePage-module-scss-module__URXJjq__countdown",
  "counter": "MaintenancePage-module-scss-module__URXJjq__counter",
  "image": "MaintenancePage-module-scss-module__URXJjq__image",
  "imageContainer": "MaintenancePage-module-scss-module__URXJjq__imageContainer",
  "logo": "MaintenancePage-module-scss-module__URXJjq__logo",
  "message": "MaintenancePage-module-scss-module__URXJjq__message",
  "startDate": "MaintenancePage-module-scss-module__URXJjq__startDate",
  "text": "MaintenancePage-module-scss-module__URXJjq__text",
});
